export default "__VITE_ASSET__8SVvr9uX__"